const DownloadIcon = () => (
  <svg className="MuiSvgIcon-root" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg> 
)

const UploadIcon = () => (
  <svg className="MuiSvgIcon-root" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"/></svg>
)

export { DownloadIcon, UploadIcon }
